import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectShare = createFeatureSelector('share');
export const selectCurrentShare = createSelector(
  selectShare,
  (share: any) => {
    let attachmentBase;
    let videoAttachmentBase;
    let audioAttachmentBase;
    let shareUrl;
    let imageAttachmentBase;
    let unknownAttachmentBase;
    let parent;
    const {
      share: instance,
      result,
      nodeId,
      isFetching,
      isInitialFetched,
      isInvalidated,
      isUnlocking,
      isPasswordRequired,
      isPasswordWrong,
      isNoteUploading,
      isNoteMoving,
      networkErrorCode,
    } = share;

    if (result && result.entities && result.entities.notes
      && instance) {
      if (result.entities.notes[instance.parentNode]) {
        parent = result.entities.notes[instance.parentNode];
      }
    }

    if (instance && instance.id && instance.securityKey) {
      const urls = getShareUrls(instance, nodeId)
      attachmentBase = urls.attachmentBase
      videoAttachmentBase = urls.videoAttachmentBase
      audioAttachmentBase = urls.audioAttachmentBase
      imageAttachmentBase = urls.imageAttachmentBase
      unknownAttachmentBase = urls.unknownAttachmentBase
      shareUrl = urls.shareUrl
    }

    return {
      instance,
      parent,
      attachmentBase,
      videoAttachmentBase,
      audioAttachmentBase,
      imageAttachmentBase,
      unknownAttachmentBase,
      shareUrl,
      isFetching,
      isInitialFetched,
      isInvalidated,
      isUnlocking,
      isPasswordRequired,
      isPasswordWrong,
      isNoteUploading,
      isNoteMoving,
      networkErrorCode,
    };
  }
);

export const getShareUrls = (instance, nodeId = '') => {
  const attachmentBase = `/attachment/${instance.id}/${instance.securityKey}`;
  const videoAttachmentBase = `/video/${instance.id}/${instance.securityKey}`;
  const audioAttachmentBase = `/audio/${instance.id}/${instance.securityKey}`;
  const imageAttachmentBase = `/image/${instance.id}/${instance.securityKey}`;
  const unknownAttachmentBase = `/unknown/${instance.id}/${instance.securityKey}`;
  let shareUrl = `/share/${instance.id}/${instance.securityKey}`;

  if (nodeId) {
    shareUrl += `/${nodeId}`;
  }

  return {
    attachmentBase,
    videoAttachmentBase,
    audioAttachmentBase,
    imageAttachmentBase,
    unknownAttachmentBase,
    shareUrl,
  }
}
